var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import './SDCC.scss';
import './AX.scss';
import { useAtom } from 'jotai';
import { fetchBadges } from '../store/BadgesStore';
import { AccountInfoAtom } from '../store/AccountStore';
import { Helmet } from 'react-helmet';
import { KodanshaNavbar } from './KodanshaNavbar/KodanshaNavbar';
import SeriesPoster from './KodanshaUIKit/SeriesPoster/SeriesPoster';
import SDCCHeader from './SDCC/images/SDCC23_Page_IMG_2880x1040_rev.png';
import AxBenefits from './AX/AXBenefits';
import EndAX from './AX/EndAX';
import { KodanshaFooter } from './KodanshaFooter/KodanshaFooter';
import IntroSDCC from './SDCC/IntroSDCC';
import ExclusivesSDCC from './SDCC/ExclusivesSDCC';
import SixSDCC from './SDCC/SixSDCC';
import SeriesSDCC from './SDCC/SeriesSDCC';
import BoothSDCC from './SDCC/BoothSDCC';
var SDCC = function (props) {
    var _a = __read(useAtom(fetchBadges), 2), data = _a[0], fetch = _a[1];
    var _b = __read(useAtom(AccountInfoAtom), 1), userData = _b[0];
    var _c = __read(useState(false), 2), redeemComics = _c[0], setRedeemComics = _c[1];
    useEffect(function () {
        if (userData.email && !data) {
            console.log('badge fetch', userData, data);
            fetch({ hardFetch: false });
        }
        if (userData.email && data) {
            console.log('here1', data);
            if (data === null || data === void 0 ? void 0 : data.some(function (b) { return b.badge.id === 2; })) {
                setRedeemComics(true);
            }
        }
    }, [data, userData.email]);
    // console.log('badge data', data);
    // console.log('props.redeemComics 1', redeemComics);
    return (_jsxs("div", { className: 'anime-expo-container', children: [_jsx(Helmet, { children: _jsx("title", { children: 'Kodansha at San Diego Comic-Con | Kodansha – Inspire Impossible Stories' }) }), _jsx(KodanshaNavbar, {}), _jsx("div", { className: 'AXHero', children: _jsx(SeriesPoster, { color: 'transparent', hover: false, ratio: 33, src: SDCCHeader, isGray: false }) }), _jsxs("div", { className: 'anime-expo-max-wrapper', children: [_jsx(IntroSDCC, { redeemComics: redeemComics }), _jsx(ExclusivesSDCC, {}), _jsx(SixSDCC, { redeemComics: redeemComics })] }), _jsx("div", { className: 'anime-expo-color', children: _jsx("div", { className: 'anime-expo-max-wrapper', children: _jsx(SeriesSDCC, {}) }) }), _jsxs("div", { className: 'anime-expo-max-wrapper', children: [_jsx(BoothSDCC, {}), _jsx(AxBenefits, {}), _jsx(EndAX, {})] }), _jsx(KodanshaFooter, {})] }));
};
export default SDCC;
